
(function(){
  var slides=document.querySelectorAll('#stage .slide'), btns=document.querySelectorAll('#thumbs button');
  var stage=document.getElementById('stage'), cur=0, dotEls=null;

  function show(i){
    cur=(i+slides.length)%slides.length;
    slides.forEach(function(s){s.classList.remove('on')});
    btns.forEach(function(x){x.classList.remove('on')});
    slides[cur].classList.add('on');
    if(dotEls) dotEls.forEach(function(d,i){d.classList.toggle('on', i===cur)});
    if(btns[cur]){
      btns[cur].classList.add('on');
      // porta la miniatura attiva dentro la riga scorrevole
      if(btns[cur].scrollIntoView) btns[cur].scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
    }
  }
  btns.forEach(function(b,i){b.addEventListener('click',function(){show(i)})});

  var dots=document.getElementById('dots');
  if(dots){
    slides.forEach(function(_,i){var d=document.createElement('i'); if(i===0) d.className='on'; dots.appendChild(d)});
    dotEls=Array.prototype.slice.call(dots.children);
  }

  // sfoglia col dito
  var x0=null, y0=null, moved=false;
  stage.addEventListener('touchstart',function(e){
    x0=e.touches[0].clientX; y0=e.touches[0].clientY; moved=false;
  },{passive:true});
  stage.addEventListener('touchmove',function(e){
    if(x0===null) return;
    var dx=e.touches[0].clientX-x0, dy=e.touches[0].clientY-y0;
    // se il gesto e' chiaramente orizzontale, e' uno sfoglio: non far scorrere la pagina
    if(Math.abs(dx)>12 && Math.abs(dx)>Math.abs(dy)*1.2){ moved=true; if(e.cancelable) e.preventDefault(); }
  },{passive:false});
  stage.addEventListener('touchend',function(e){
    if(x0===null) return;
    var dx=(e.changedTouches[0].clientX-x0), dy=(e.changedTouches[0].clientY-y0);
    if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) show(cur + (dx<0?1:-1));
    x0=null; y0=null;
  },{passive:true});

  // e con le frecce, per chi e' da computer
  document.addEventListener('keydown',function(e){
    if(e.key==='ArrowRight') show(cur+1);
    if(e.key==='ArrowLeft') show(cur-1);
  });
  var bar=document.getElementById('bar'), box=document.querySelector('.pricebox');
  var last=document.querySelector('.final');
  (document.querySelector('.cgc')||document.body).classList.add('has-bar');
  function onScroll(){
    var past = box.getBoundingClientRect().bottom < 0;
    // si nasconde quando il blocco d'acquisto finale entra nel viewport
    var atEnd = last && last.getBoundingClientRect().top < window.innerHeight * 0.9;
    bar.classList.toggle('on', past && !atEnd);
  }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  var targets=document.querySelectorAll('section .head, .split>div, .split>img, .split>.week, .card, .pr, .m, .box2, .spec, .ladder, .rec, .inter, .warn, .faq, .band .txt');
  targets.forEach(function(t){t.classList.add('rv')});
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.05});
    targets.forEach(function(t){io.observe(t)});
  } else { targets.forEach(function(t){t.classList.add('in')}); }
})();
